import type { ComponentType } from 'react';
import React from 'react';
import type { IconProps } from '@noths/polaris-client-ribbons-design-system';

import * as styles from './IconCircle.styles';

interface IconCircleProps {
  Icon: ComponentType<IconProps>;
}

export const IconCircle = ({ Icon }: IconCircleProps) => {
  return (
    <span css={styles.circle}>
      <Icon color="var(--brand-purple-base)" height={16} width={16} />
    </span>
  );
};
